import { render, staticRenderFns } from "./SurveyRevisionComments.vue?vue&type=template&id=0ed6b608&"
import script from "./SurveyRevisionComments.vue?vue&type=script&lang=js&"
export * from "./SurveyRevisionComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports